import * as React from 'react';

export const GoalEvaluationTab = () => {
  return <div>TBA tab content: GoalEvaluationTab</div>;
};
